var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHamburg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 600,
    height: 400,
    viewBox: "0 0 600 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#da121a",
    d: "M0 0h600v400H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.3 75.37s.508-8.848-7.287-10.24v-9.525h6.27v-4.067h-6.27v-5.204h-3.886v5.204h-6.27v4.067h6.27v9.525c-7.795 1.391-7.287 10.24-7.287 10.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.9 94.91h44.14c0-11.98-11.11-21.58-22.07-21.58s-22.07 9.6-22.07 21.58z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.9 105.5l2.5-.853V94.9h-50.73v9.747l2.5.853z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.4 200.6v-95.11h-44.85v95.11"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M207.9 276.7c7.371-33.4 4.699-66.48 4.699-66.48h174.8s-2.672 33.08 4.699 66.48c7.999 36.26 15.17 48.8 15.17 48.8v14.59h-214.5l-.019-14.59s7.148-12.54 15.15-48.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "b",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.2,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.9 82.39h8.365v11.13h5.4V82.39h8.688v11.13h5.717V82.39h8.319v21.92l-2.792 1.205h-45.46l-3.361-1.205V82.39h8.745v11.13h6.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.1 105.5h45.4v96.43h-45.4zM232.6 69.3l4.12-7.13-4.12-7.13h8.24l4.12-7.13 4.12 7.13h8.24l-4.12 7.13 4.12 7.13h-8.24l-4.12 7.14-4.12-7.14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301 185.4h-8.031v13.06h-13.05V185.4h-14.34v13.06h-11.96V185.4h-13.88v13.06h-11.87V185.4h-16.17v24.74l3.852.94h85.45"
  })), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2,
    d: "M222.1 106h45.36"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2.5,
    d: "M266.4 340.1v-73.78c0-6.687 9.045-30.81 33.6-30.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277 340.1v-69.84c0-11.39 9.074-24.43 23-24.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    fill: "#000",
    d: "M283.9 321.3c0-3.16 1.18-3.16 2.1-3.16.93 0-.11 1.27-.11 3s1 3.3.11 3.3-2.1-.28-2.1-3.16zm-6.9-.1h6.451"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2,
    d: "M193 325.5h73"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    y: -50
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "matrix(-1 0 0 1 600 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.2 210.2h175.6M277.8 106h44.16",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 245.8v94.27"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburg);
export default __webpack_public_path__ + "static/media/hamburg.efa19bb119acd07d2c7eb00b4db249c8.svg";
export { ForwardRef as ReactComponent };